import React from 'react';

import { SelectInput } from 'react-admin';
import { SelectEnumInput } from './SelectEnumInput';


export const DocumentTemplateTypeSelect = (props) => (
	<SelectEnumInput
		key={"document-template-type"} 
		resettable 
		enumName="document-template-type" 
		enumObj={props.enumObj} 
		style={{minWidth: "240px"}} 
		{...props}/>
);
